import { useEffect } from 'react';
import { useRoomParticipants } from '../../core/client/hooks';
import type { CoopPayload, CoopRuntime } from '../../core/types/payloads/coop.types';
import type { RoomPhase } from '../../core/types/room.types';

export function useCoopTurnInit({
  payload,
  runtime,
  phase,
  dispatch,
}: {
  payload: CoopPayload;
  runtime: CoopRuntime;
  phase?: RoomPhase;
  dispatch?: (action: { type: string; payload?: unknown }) => void;
}) {
  const { participants } = useRoomParticipants();

  useEffect(() => {
    if (phase !== 'ACTIVE' || !dispatch) return;
    if (payload.board.kind === 'crossword') return;
    if (runtime.turnOrder.length > 0) return;
    const ids = participants.map((p) =>
      payload.settings?.turnUnit === 'team' ? p.teamId ?? p.participantId : p.participantId,
    ).filter(Boolean);
    const unique = [...new Set(ids)];
    if (unique.length === 0) return;
    dispatch({ type: 'INIT_TURNS', payload: unique });
  }, [dispatch, participants, payload.board.kind, payload.settings?.turnUnit, phase, runtime.turnOrder.length]);
}
